import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Header from "../../header/Header";
import Footer from "../../footer/Footer";
import { httpNonToken, endPoints } from "../../../globalConf/http-non-token";
import CustomToastify, { toastMes } from "../../../globalConf/notification";
import Styles from "../requestTracking.module.css";
import Loading from "../../loading/loading";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import axios from "axios";
import {
  Box,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import "../style.css";

const RequestAiTracking = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const dataAuth = JSON.parse(localStorage.getItem("userOP"));

  const [request, setRequest] = useState(null);
  const [load, setLoad] = useState(true);
  const [allAnatomy, setAllAnatomy] = useState([]);

  const getStyle = (id) => {
    if (id === 1) return { color: "#3285c5" };
    if (id === 2) return { color: "#3285c5", borderLeft: "4px solid #3285c5" };
    if (id === 3) return { color: "#3285c5", borderLeft: "4px solid #3285c5" };
    if (id === 4) return { color: "#ff4d4d", borderLeft: "4px solid #ff4d4d" };
    if (id === 5) return { color: "#ff8c00", borderLeft: "4px solid #ff8c00" };
    if (id === 6) return { color: "#ff8c00", borderLeft: "4px solid #ff8c00" };
    if (id === 7) return { color: "#008000", borderLeft: "4px solid #008000" };
    if (id === 8) return { color: "#008000", borderLeft: "4px solid #008000" };
    if (id === 9) return { color: "#008000", borderLeft: "4px solid #008000" };
    if (id === 10) return { color: "#008000", borderLeft: "4px solid #008000" };
    if (id === 11) return { color: "#ff8c00", borderLeft: "4px solid #ff8c00" };
    if (id === 12) return { color: "#3285c5", borderLeft: "4px solid #3285c5" };
    if (id === 13) return { color: "#008000", borderLeft: "4px solid #008000" };
    return { color: "#3285c5", borderLeft: "4px solid #3285c5" };
  };

  useEffect(() => {
    (async () => {
      if (!dataAuth) {
        navigate("/login");
        return;
      }

      try {
        const numericId = id.toString().replace("AI-", "");
        const aiReqRes = await axios.get(
          `https://py.qubx3d.com/api/v1/ai-segmentation/requests/${numericId}/`,
          {
            headers: {
              Authorization: `Bearer ${dataAuth.access}`,
            },
          },
        );

        if (aiReqRes.data) {
          const aiReq = aiReqRes.data;
          const aiStatusMapping = {
            pending_payment: { id: 3, name: "Pending Payment" },
            processing: { id: 5, name: "Processing" },
            completed: { id: 13, name: "Completed" },
            failed: { id: 4, name: "Failed" },
            waiting_upload: { id: 2, name: "Waiting for Upload" },
          };

          const mappedStatus = aiStatusMapping[aiReq.status] || {
            id: 0,
            name: aiReq.status_display || aiReq.status || "AI Request",
          };

          const transformed = {
            ...aiReq,
            id: id,
            isAiRequest: true,
            created_by: { fullname: "AI System" },
            patient: {
              fullname:
                aiReq.patient_name || aiReq.patient?.fullname || "AI Patient",
              mobile: aiReq.patient_phone || aiReq.patient?.mobile || "",
            },
            doctor: {
              fullname:
                aiReq.doctor_name || aiReq.doctor?.fullname || "AI Doctor",
              mobile: aiReq.doctor_phone || "",
            },
            service: {
              name: "AI Segmentation",
              type: { id: 4, name: "AI Segmentation" },
            },
            statu: { ...mappedStatus, SLA: 0 },
            quality_assurence: false,
          };

          setRequest(transformed);
        }
        setLoad(false);
      } catch (error) {
        toastMes.error(
          error.response?.data?.message || "Failed to fetch AI request details",
        );
        setLoad(false);
      }
    })();
  }, [id]);

  if (load || !request) {
    return <Loading />;
  }

  return (
    <div className="bg_dark">
      <Header />
      <div className="bg_light p-2 rounded-top-20">
        <div className="m-4">
          <div className="ps-2">
            <div className="overflow-hidden fn_main fn_sm d-flex align-items-center mb-4">
              <div className="float-start me-2">
                <button
                  onClick={() => navigate(-1)}
                  className="fw-bold border-0 f-primary bg-transparent btn-back"
                >
                  <ArrowBackIosNewIcon />
                  <h5 className="float-end text-primary ms-2">{request.id}</h5>
                </button>
              </div>
              <div className="mb-1">
                <span>{new Date(request.created_at).toLocaleString()}, </span>
                <span>{request.created_by.fullname}</span>
              </div>
              <div
                className="me-2 mx-3 px-2 request-box-info"
                style={{ position: "relative" }}
              >
                <h6 style={getStyle(request.statu?.id)}>
                  {request.statu?.name}
                </h6>
              </div>
            </div>
          </div>

          <div className="row">
            <div className={`col-lg-7 ms-3 ${Styles.info_boxes}`}>
              <div className="row">
                <div
                  className={`col text-center bg-white border border-primary me-3 ${Styles.info_box}`}
                >
                  <img
                    alt="patient card"
                    className="w-50 d-block mx-auto my-3"
                    src={"/images/global/nurse_patient.svg"}
                  />
                  <h6 className="mb-1">{request.patient.fullname}</h6>
                  <p className="mt-1" style={{ fontSize: "12px" }}>
                    {request.patient.mobile}
                  </p>
                </div>
                <div
                  className={`col text-center bg-white border border-primary me-3 ${Styles.info_box}`}
                >
                  <img
                    alt="doctor card"
                    className="w-50 d-block mx-auto my-3"
                    src={"/images/global/medical_doctor.svg"}
                  />
                  <h6 className="mb-1">{request.doctor.fullname}</h6>
                  <p className="mt-1" style={{ fontSize: "12px" }}>
                    {request.doctor.mobile}
                  </p>
                </div>
                <div
                  className={`col text-center bg-white border border-primary me-3 ${Styles.info_box}`}
                >
                  <img
                    alt="service card"
                    className="w-50 d-block mx-auto my-3"
                    src={"/images/global/3d-printing.svg"}
                  />
                  <h6>{request.service.type.name}</h6>
                  <span>{request.service.name}</span>
                </div>
              </div>

              <div className="row mt-4">
                <div className="col-12">
                  <div className="bg-white p-4 rounded border border-primary">
                    <h5 className="mb-3">Request Details</h5>
                    <div className="row">
                      <div className="col-md-6 mb-3">
                        <p className="mb-1 fw-bold">Anatomy:</p>
                        <p className="text-secondary">
                          {request.anatomy_display || "AI Auto-detected"}
                        </p>
                      </div>
                      <div className="col-md-6 mb-3">
                        <p className="mb-1 fw-bold">Modality:</p>
                        <p className="text-secondary">
                          {request.modality || "CT/MRI"}
                        </p>
                      </div>
                      <div className="col-md-12">
                        <p className="mb-1 fw-bold">Case Description:</p>
                        <p className="text-secondary">
                          {request.description || "No description provided."}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="row mt-4">
                <div className="col-12">
                  <ul className="list-unstyled">
                    <li className="d-flex align-items-center justify-content-between mb-3">
                      <h5>Price</h5>
                      <span>{request.price} Egp</span>
                    </li>
                    <li className="d-flex align-items-center justify-content-between border-bottom mb-3">
                      <h5>Discount</h5>
                      <span>0 Egp</span>
                    </li>
                    <li className="d-flex align-items-center justify-content-between mb-3">
                      <h5>Total</h5>
                      <span>{request.price} Egp</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="col-lg-4">
              <div className="border-primary border_dash rounded mb-3 p-3 bg-white">
                <h6 className="mb-3">Files & Assets</h6>
                <ul className="list-unstyled">
                  {request.input_file ? (
                    <li className="mb-3 d-flex justify-content-between align-items-center border-bottom pb-2">
                      <div className="overflow-hidden">
                        <p className="mb-0 small fw-bold text-truncate">
                          Input Sequence
                        </p>
                        <span className="text-secondary x-small">
                          NIfTI / DICOM
                        </span>
                      </div>
                      <a
                        href={request.input_file}
                        target="_blank"
                        rel="noreferrer"
                      >
                        <img
                          alt="download"
                          src="/images/requestTracking/file-download.svg"
                          width="24"
                        />
                      </a>
                    </li>
                  ) : null}

                  {request.output_file ? (
                    <li className="mb-3 d-flex justify-content-between align-items-center border-bottom pb-2">
                      <div className="overflow-hidden">
                        <p className="mb-0 small fw-bold text-truncate text-primary">
                          Segmentation Result
                        </p>
                        <span className="text-secondary x-small">
                          STL / OBJ
                        </span>
                      </div>
                      <a
                        href={request.output_file}
                        target="_blank"
                        rel="noreferrer"
                      >
                        <img
                          alt="download"
                          src="/images/requestTracking/file-download.svg"
                          width="24"
                        />
                      </a>
                    </li>
                  ) : (
                    request.status === "processing" && (
                      <div className="alert alert-info py-2 px-3 small">
                        AI is currently processing...
                      </div>
                    )
                  )}
                </ul>
              </div>

              <div className="bg-white p-3 border border-primary rounded mt-3 h_300 overflow-scroll">
                <h6>Status Log</h6>
                <hr className="my-2" />
                <div className="p-2 bg_light rounded small mb-2">
                  <div className="d-flex justify-content-between mb-1">
                    <span className="fw-bold">AI System</span>
                    <span className="text-secondary x-small">
                      {new Date(request.created_at).toLocaleTimeString()}
                    </span>
                  </div>
                  Request received and registered in AI queue.
                </div>
                {request.status === "processing" && (
                  <div className="p-2 bg_light rounded small mb-2">
                    <div className="d-flex justify-content-between mb-1">
                      <span className="fw-bold">AI Backend</span>
                      <span className="text-secondary x-small">Now</span>
                    </div>
                    Segmentation model is currently running on GPU.
                  </div>
                )}
                {request.status === "completed" && (
                  <div className="p-2 bg-success bg-opacity-10 rounded small">
                    <div className="d-flex justify-content-between mb-1">
                      <span className="fw-bold text-success">AI Backend</span>
                      <span className="text-secondary x-small">Done</span>
                    </div>
                    Segmentation completed. Result file generated successfully.
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default RequestAiTracking;
